@import "../../../../../shared/styles/base";
@import "../../../../../shared/components/design-system/Button/styles/surfaces";

.OverTimeHeader {
  display: grid;
  @include button-group;

  grid-template-columns: repeat(4, 1fr) auto;
  grid-template-rows: repeat(2, auto);
  padding-bottom: 0.5rem;
  gap: 1rem;

  &__filterButton {
    margin: auto 0 0.1rem;
  }

  &__filterChips {
    grid-area: 2 / 1 / 3 / 6;
    padding-bottom: 0.5rem;
  }

  @media (max-width: $tablet) {
    grid-template-columns: repeat(2, 1fr) auto;
    grid-template-rows: repeat(3, auto);

    &__filterButton {
      grid-area: 1 / 3 / 2 / 4;
    }

    &__filterChips {
      grid-area: 3 / 1 / 4 / 4;
    }
  }

  @media (max-width: 30rem) {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(6, auto);

    &__duration {
      grid-area: 1 / 1 / 2 / 3;
    }

    &__year {
      grid-area: 2 / 1 / 3 / 3;
    }

    &__startMonth {
      grid-area: 3 / 1 / 4 / 3;
    }

    &__comparisonYear {
      grid-area: 4 / 1 / 5 / 3;
    }

    &__filterButton {
      grid-area: 5 / 2 / 6 / 3;
    }

    &__filterChips {
      grid-area: 6 / 1 / 7 / 3;
    }
  }
}

.chartTypeSelector {
  max-width: 15em;
}
